import { defineStore } from 'pinia';

export const useOptionsStore = defineStore('options', {
    state: () => ({
        roles: [],
        statuses: [],
        provinces: [],
        twoFactorMethods: [],
        securityQuestionTemplates: [],
        securityCheckpoint: false,
        addressTypes: [],
        productTypes: [],
        orderTypes: [],
        compoundTypes: [],
        labStatuses: [],
        pharmacyStatuses: [],
        orderStatuses: [],
        labProducts: [],
        units: [],
        pharmacies: [],
        pricingSchemes: [],
    }),
    actions: {
        reset() {
            this.$reset();
        },
    },
    getters: {
        roleOptions: (state) => {
            return state.roles;
        },

        provinceOptions: (state) => {
            return state.provinces.map((province) => ({
                label: province.name,
                value: province.id,
            }));
        },

        addressTypeOptions: (state) => {
            return state.addressTypes.map((addressType) => ({
                label: addressType.name,
                value: addressType.id,
            }));
        },

        productTypeOptions: (state) => {
            return state.productTypes.map((productType) => ({
                label: productType.name,
                value: productType.id,
            }));
        },

        orderTypeOptions: (state) => {
            return state.orderTypes.map((orderType) => ({
                label: orderType.name,
                value: orderType.id,
            }));
        },

        compoundTypeOptions: (state) => {
            return state.compoundTypes.map((compoundType) => ({
                label: compoundType.display_name,
                value: compoundType.id,
                prep_time_hrs: compoundType.prep_time_hrs,
            }));
        },

        labStatusOptions: (state) => {
            return state.labStatuses.map((labStatus) => ({
                label: labStatus.name,
                value: labStatus.id,
            }));
        },

        orderStatusOptions: (state) => {
            return state.orderStatuses.map((orderStatus) => ({
                label: orderStatus.name,
                value: orderStatus.id,
            }));
        },

        pharmacyStatusOptions: (state) => {
            return state.pharmacyStatuses.map((pharmacyStatus) => ({
                label: pharmacyStatus.name,
                value: pharmacyStatus.id,
            }));
        },

        unitOptions: (state) => {
            return state.units.map((unit) => ({
                label: unit.name,
                value: unit.id,
            }));
        },

        pharmacyOptions: (state) => {
            return state.pharmacies.map((pharmacy) => ({
                label: pharmacy.name,
                value: pharmacy.id,
            }));
        },

        pricingSchemeOptions: (state) => {
            return state.pricingSchemes.map((pricingScheme) => ({
                label: pricingScheme.scheme_name,
                value: pricingScheme.id,
            }));
        },
    },
});

// HMR
if (import.meta.hot) {
    import.meta.hot.accept(useOptionsStore.acceptHMRUpdate);
}
